import React, { FunctionComponent } from 'react';
import { pattyG } from '../assets/Images';
import { SummaryCard } from '../styles/SummaryCard';
import { CleanTestimonial, Testimonial } from '../styles/Testimonial';
import { DemoComponent, DemoContainer, DemoHeader } from './Demo';

// Demonstration of mid-level reusable components
export const DemoElements: FunctionComponent = () => {
  return (
    <DemoContainer>
      <DemoComponent>
        <DemoHeader>Testimonial</DemoHeader>
        <p>
          <Testimonial
            name="Internet Person"
            stars={5}
            testimonial={['This is a fascinating testimonial box.']}
            image={pattyG}
            date="02/03/21"
          />
        </p>
        <p>
          <CleanTestimonial
            name="Internet Person"
            date="02/03/21"
            stars={5}
            body={['This is a fascinating clean testimonial box.']}
            image={pattyG}
          />
        </p>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>SummaryCard</DemoHeader>
        <p>
          <SummaryCard
            heading="Summary Card"
            data={[
              {
                items: [
                  { heading: 'fruit', items: ['banana', 'apple', 'orange'] },
                  { heading: 'vegetables', items: ['tomato', 'broccoli'] },
                ],
              },
              {
                heading: 'office supplies',
                items: [
                  {
                    heading: 'consumables',
                    items: ['printer paper', 'paperclips', 'rubber bands'],
                  },
                ],
              },
            ]}
          />
        </p>
      </DemoComponent>
    </DemoContainer>
  );
};
